import gql from 'graphql-tag'

export default gql`
	query getERPStatistics($params: StatisticERPParams!) {
		cashAssist {
			getERPStatistics(params: $params) {
				id
				creditClientName
				cashRegisterId
				cashRegisterName
				orderTypeName
				dateOrder
				dateSend
				dateReceive
				userName
				deliveryNoteNumber
				importNumber
				total
				destination
			}
		}
	}
`
